import React from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { PlayArrow as PlayArrowIcon } from "@mui/icons-material";
import { BaseActionRendererProps, EmailData, getActionData, useExecutionOverride } from "./BaseActionRenderer";

const openGmailDraft = (to: string, subject: string, body: string) => {
  const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(to)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.open(url, "_blank");
};

export const EmailActionRenderer: React.FC<BaseActionRendererProps> = ({ actionData, onExecuteAction, actionId, executingActions, isExecuting, onOverrideExecution }) => {
  const emailData = getActionData(actionData) as EmailData;

  // Signal to parent that this renderer handles its own execution
  useExecutionOverride(onOverrideExecution);

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body1" sx={{ fontWeight: 500 }} gutterBottom>
        Draft Email
      </Typography>
      <Typography variant="body2" gutterBottom>
        <b>To:</b> {emailData.to || <i>(not specified)</i>}
      </Typography>
      <Typography variant="body2" gutterBottom>
        <b>Subject:</b> {emailData.subject || <i>(not specified)</i>}
      </Typography>
      <Typography variant="body2" gutterBottom>
        <b>Body:</b>
        <Box sx={{ whiteSpace: "pre-line", ml: 2, mt: 0.5 }}>{emailData.body || <i>(not specified)</i>}</Box>
      </Typography>

      {/* Execute button for proposed actions */}
      {onExecuteAction && actionId && (
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={executingActions?.has(actionId) ? <CircularProgress size={16} color="inherit" /> : <PlayArrowIcon />}
          disabled={executingActions?.has(actionId)}
          onClick={() => {
            openGmailDraft(emailData.to || "", emailData.subject || "", emailData.body || "");
            setTimeout(() => onExecuteAction(actionId), 500); // Mark as executed after opening
          }}
          sx={{ mt: 2 }}
        >
          {executingActions?.has(actionId) ? "Executing..." : isExecuting ? "Executing..." : "Open Draft in Gmail"}
        </Button>
      )}
    </Box>
  );
};
